import {Redirect, Route, useParams} from "react-router-dom";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import PageRoutes from "../constants/page-routes";
import landingPageReducer from "../modules/landing-page/redux/landing-page.reducer";

const DynamicFormRoute = ({component: Component, ...rest}) => {
    const dispatch = useDispatch();

    const {accountVerificationData} = useSelector(({loginReducer}) => loginReducer);

    if (accountVerificationData) {
        return <Route {...rest} render={(props) => <Component {...props} />}/>;
    } else {

        dispatch(
            landingPageReducer.actions.setLandingPageData({
                applyNewProduct: false,
                editAnApplication: false,
                iHaveToken: false,
                consentApplication: false,
                dynamicForm: true,
                dynamicFormParam: window.location.pathname.split("/")[2]
            }),
        );

        return <Redirect to={`/${PageRoutes.LOGIN}`}/>;
    }
};
export default DynamicFormRoute;
